
import { Component, Prop, Vue } from "vue-property-decorator";
import LogTable from "@/components/logs/LogTable.vue";
import MylobyAutocomplete from "@/components/generic/autocomplete.vue";

@Component({
  components: { LogTable, MylobyAutocomplete },
})

export default class CustomerSuccessLogsTab extends Vue {

  @Prop({ default: null })
  public userId: number;

  private logs: any = [];
  private loading: boolean = false;
  private selectedCompany: any = null;
  private lastParams: any = null;

  private onCompanyChange(): void {
    if (this.logs) {
      this.getLogs(this.lastParams);
    }
  }

  private getLogs(params?: any) {
    this.lastParams = params;
    if (this.userId) {
      this.loading = true;
      this.$store.dispatch("logs/getLogs", {
        query: {
          currentPage: "user",
          entityId: this.userId,
          entityType: "user",
          companyId: this.selectedCompany?.companyId,
          ...params,
        },
      }).then((res) => {
        this.logs = res;
      }).finally(() => {
        this.loading = false;
        this.$emit("loaded");
      });
    }
  }
}
